import { Card, CardContent, Grid } from "@mui/material";
import {
  GridColDef,
  GridInitialState,
  GridRenderCellParams,
} from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import { useError } from "../../../contexts/ErrorContext";
import useApi from "../../../hooks/useGaneshApi";
import GaneshDataGrid from "../../DataGrid/GaneshDataGrid";
import { formatNumber } from "utils/formatting";

type BrandedCountByCountry_T = {
  id: number;
  country_code: string;
  country_name: string;
  poi_percent_branded: string;
  total_active_poi_count: number;
  total_branded_poi_count: number;
};
const defaultGridState: GridInitialState = {
  filter: {
    filterModel: {
      items: [],
    },
  },
  sorting: { sortModel: [] },
  pagination: { paginationModel: { pageSize: 25, page: 0 } },
  pinnedColumns: { left: [] },
  columns: { columnVisibilityModel: {} },
  density: "compact",
};

const BrandedCountByCountry: React.FC<any> = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [brandedCountByCountryData, setBrandedCountByCountryData] = useState<
    BrandedCountByCountry_T[]
  >([]);

  const { showError } = useError();
  const { apiRequest } = useApi();

  const fetchBrandedCountByCountry = async () => {
    try {
      setLoading(true); // Set loading to true before the API request
      const response = await apiRequest<BrandedCountByCountry_T[]>(
        `/brand_reports/insights/get_branded_counts_by_country`,
        { method: "GET" }
      );
      if (response.data) {
        const formattedData = response.data.map((item) => ({
          ...item,
          total_active_poi_count: Number(item.total_active_poi_count),
          total_branded_poi_count: Number(item.total_branded_poi_count),
        }));
        setBrandedCountByCountryData(formattedData);
      }
    } catch (error) {
      console.error(error);
      showError(`Error fetching branded count by country data.`);
    } finally {
      setLoading(false); // Set loading to false after data is fetched
    }
  };

  useEffect(() => {
    fetchBrandedCountByCountry();
  }, []);

  const columns_def: GridColDef[] = [
    {
      field: "country_code",
      headerName: "Country Code",
      width: 150,
    },
    {
      field: "country_name",
      headerName: "Country",
      width: 200,
    },
    {
      field: "poi_percent_branded",
      headerName: "POI % Branded",
      width: 150,
    },
    {
      field: "total_active_poi_count",
      headerName: "Total Active POI Count",
      width: 200,
      renderCell: (params: GridRenderCellParams<Number>) =>
        formatNumber(params.value),
    },
    {
      field: "total_branded_poi_count",
      headerName: "Brand Count by Country",
      width: 200,
      renderCell: (params: GridRenderCellParams<Number>) =>
        formatNumber(params.value),
    },
  ];

  return (
    <Grid container spacing={2}>
      {/* Data Grid Section */}
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <GaneshDataGrid
              loading={loading}
              data={brandedCountByCountryData}
              columns={columns_def}
              gridId="brandedCountByCountryGrid"
              defaultGridState={defaultGridState}
              customHeight="550px"
              showGridSaver={false}
              getRowId={(row: BrandedCountByCountry_T) => row.id}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default BrandedCountByCountry;
